module.exports = __webpack_public_path__ + "static/media/dfn.a13d7f22.svg";